import api from "api/api";

// Fast & Furious — candidate prospecting (sourcing), datatrack service.
// declaration_id required at creation; mutations allowed only
// on the owned draft (STATUS_DRAFT) on the back side.

export const getProspectsByDeclarationQuery = async ({ declarationId }) =>
  await api.get(`/datatrack/prospect?declaration_id=${declarationId}`);

export const createProspectQuery = async ({ payload }) =>
  await api.post(`/datatrack/prospect`, payload);

export const updateProspectQuery = async ({ id, payload }) =>
  await api.put(`/datatrack/prospect/${id}`, payload);

export const deleteProspectQuery = async ({ id }) =>
  await api.delete(`/datatrack/prospect/${id}`);
